export const PAYMENT_METHODS = {
  CRYPTO: 'crypto',
  CREDIT_CARD: 'credit_card',
} as const
export type TPaymentMethod = (typeof PAYMENT_METHODS)[keyof typeof PAYMENT_METHODS]
